module.exports = __webpack_public_path__ + "img/vard5.00b620ca.png";